var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atoms/icons/inventory",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86956522,3.47865314 L6.86956522,5.40191506 L17.6304348,5.40191506 L17.6304348,3.47865314 L20.5,3.47865314 L20.5,23 L4.19635239,23 L4,3.47865314 L6.86956522,3.47865314 Z M16.8333333,17.5 L7.66666667,17.5 L7.66666667,18.875 L16.8333333,18.875 L16.8333333,17.5 Z M16.8333333,14.75 L7.66666667,14.75 L7.66666667,16.125 L16.8333333,16.125 L16.8333333,14.75 Z M16.8333333,12 L7.66666667,12 L7.66666667,13.375 L16.8333333,13.375 L16.8333333,12 Z M16.8333333,9.25 L7.66666667,9.25 L7.66666667,10.625 L16.8333333,10.625 L16.8333333,9.25 Z M14.7895358,1 L14.7895358,2.25715689 L16.2018408,2.25710778 L16.2018408,3.93333333 L8.31228325,3.93333333 L8.31228325,2.25715689 L9.74671895,2.25715689 L9.74671895,1 L14.7895358,1 Z",
    id: "inventory",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.44f2df65fb08f0a947be32e86d580693.svg";
export { ForwardRef as ReactComponent };